// REACT_APP_HOSTED_KYC_HOSTS (none by default): hosts that serve only the hosted page. Leaf module,
// shared with the Vite plugin that writes them into index.html's head guard.

// Bare hostnames only, so no value can put script into the head guard.
const HOSTNAME = /^[a-z0-9-]+(\.[a-z0-9-]+)*$/

export const parseHostedKycHosts = (raw: string | undefined): string[] =>
  (raw ?? '')
    .split(',')
    .map((host) => host.trim().toLowerCase())
    .filter((host) => HOSTNAME.test(host))
